<template>
	<div class="page">
		<div class="hero">
			<div class="hero-bg"></div>
			<i class="el-icon-message"></i>
			<h1>高级版邮箱群发系统</h1>
			<p class="subtitle">模板丰富 · 个性化定制 · 自动化工作流 · 送达率优化 · 数据追踪</p>
			<div class="badges">
				<span class="badge">并发发送</span>
				<span class="badge">模板中心</span>
				<span class="badge">自动化</span>
				<span class="badge">数据分析</span>
			</div>
			<ul class="shapes">
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li>
			</ul>
			<div class="actions">
				<el-button class="custom-button" @click="open('https://qf.shuhailinghang.cn/')">前往高级版邮箱群发系统</el-button>
			</div>
			<ul class="ribbons"><li></li><li></li><li></li></ul>
		</div>
		<div class="section">
			<h2>系统介绍</h2>
			<div class="cards">
				<div class="card intro-card">
					<p>这是一款适合开展全球邮件群发的高级版专业平台，提供强大的一体化大规模并发邮件解决方案。通过大量行业及场景邮件模板（图文并茂）、个性化定制等功能，帮助你快速创建有吸引力的电子邮件；同时还提供智能自动化工作流与送达率优化，配合数据追踪分析让邮件营销效果更可衡量、更高效。</p>
				</div>
			</div>
		</div>
		<div class="bottom-section">
			<div class="card feature-grid">
				<div class="feature"><i class="el-icon-c-scale-to-original"></i><span>大规模并发</span></div>
				<div class="feature"><i class="el-icon-picture"></i><span>模板中心</span></div>
				<div class="feature"><i class="el-icon-cpu"></i><span>自动化流程</span></div>
				<div class="feature"><i class="el-icon-data-analysis"></i><span>数据追踪</span></div>
			</div>
		</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AdvancedMailer',
	methods: { 
		open(url){ 
			try {
				// 尝试使用 window.open
				const newWindow = window.open(url, '_blank');
				
				// 检查是否被阻止
				if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
					// 如果弹窗被阻止，尝试直接跳转
					window.location.href = url;
				}
			} catch (error) {
				console.error('跳转失败:', error);
				// 如果都失败了，尝试直接跳转
				window.location.href = url;
			}
		} 
	}
}
</script>

<style scoped>
.page { padding: 24px 24px 48px; width: 100%; max-width: none; margin: 0 auto; background: linear-gradient(180deg, #fbfaff 0%, #f7f4ff 60%, #f5f2ff 100%); border-radius: 12px; min-height: calc(100vh - 48px); display: flex; flex-direction: column; }
.hero { position: relative; overflow: hidden; background: linear-gradient(135deg, #f0f5ff 0%, #f9f0ff 100%); padding: 40px 24px; border-radius: 12px; text-align: center; }
.hero-bg { position: absolute; inset: -20%; background: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.85), transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.65), transparent 45%), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.55), transparent 50%); filter: blur(8px); }
.hero i { position: relative; z-index: 1; font-size: 56px; color: #722ed1; animation: pop 2.6s ease-in-out infinite; }
.hero h1 { position: relative; z-index: 1; margin: 28px 0 28px; font-size: 36px; letter-spacing: 0.3px; background: linear-gradient(90deg, #2b2140, #722ed1, #2b2140) !important; -webkit-background-clip: text !important; background-clip: text !important; color: transparent !important; text-shadow: none !important; background-size: 200% 100%; animation: titleShimmer 6s linear infinite; }
.subtitle { position: relative; z-index: 1; color: #2f2950; margin-bottom: 32px; font-size: 18px; font-weight: 700; line-height: 2.1; padding: 8px 12px; background: rgba(255,255,255,0.7); border-radius: 8px; display: inline-block; }
.badges { position: relative; z-index: 1; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; margin: 20px 0 32px; }
.badge { background: rgba(114,46,209,0.14); color: #2b2140; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; text-shadow: 0 1px 1px rgba(255,255,255,0.6); }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }
@keyframes pop { 0%,100% { transform: scale(1);} 50% { transform: scale(1.06);} }
.shapes { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; }
.shapes li { position: absolute; left: 0; top: -20%; width: 28px; height: 28px; background: rgba(114,46,209,0.28); border-radius: 6px; animation: fallDown 12s linear infinite; }
.shapes li:nth-child(1){ left: 8%; width: 36px; height: 36px; animation-duration: 14s; animation-delay: .2s; }
.shapes li:nth-child(2){ left: 24%; width: 50px; height: 50px; animation-duration: 16s; animation-delay: .6s; }
.shapes li:nth-child(3){ left: 36%; width: 30px; height: 30px; animation-duration: 12s; animation-delay: .1s; }
.shapes li:nth-child(4){ left: 58%; width: 44px; height: 44px; animation-duration: 18s; animation-delay: .4s; }
.shapes li:nth-child(5){ left: 74%; width: 28px; height: 28px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(6){ left: 88%; width: 62px; height: 62px; animation-duration: 17s; animation-delay: .5s; }
.shapes li:nth-child(7){ left: 16%; width: 26px; height: 26px; animation-duration: 11s; animation-delay: .7s; }
.shapes li:nth-child(8){ left: 46%; width: 42px; height: 42px; animation-duration: 15s; animation-delay: .9s; }
.shapes li:nth-child(9){ left: 66%; width: 34px; height: 34px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(10){ left: 82%; width: 48px; height: 48px; animation-duration: 16s; animation-delay: .8s; }
.shapes li:nth-child(11){ left: 28%; width: 24px; height: 24px; animation-duration: 12s; animation-delay: .4s; }
.shapes li:nth-child(12){ left: 48%; width: 54px; height: 54px; animation-duration: 18s; animation-delay: .6s; }
@keyframes fallDown { 0% { transform: translateY(-20vh) rotate(0deg); opacity: .9; } 100% { transform: translateY(120vh) rotate(360deg); opacity: .6; } }
.feature { transition: transform .25s ease, box-shadow .25s ease; }
.feature:hover { transform: translateY(-3px); box-shadow: 0 10px 18px rgba(114,46,209,0.12); }
.feature i { font-size: 18px; margin-right: 6px; }
.actions { position: relative; z-index: 1; margin-top: 28px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
.section { margin-top: 16px; }
.section h2 { margin: 0 0 32px; }
.cards { display: grid; grid-template-columns: 1fr; gap: 24px; }
.card { background: #ffffff; border: 1px solid #ece6ff; border-radius: 12px; }
.intro-card { padding: 24px 28px; color: #372f5a; line-height: 2.0; font-size: 16.5px; }
.intro-card p { max-width: 900px; margin: 0 auto; word-break: break-word; }
.feature-grid { padding: 16px; display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 12px; }
.feature { background: #f6f3ff; border: 1px solid #ece6ff; padding: 12px; border-radius: 10px; display: flex; align-items: center; gap: 8px; justify-content: center; color: #463a8a; }
.bottom-section { margin-top: auto; padding-top: 32px; padding-bottom: 24px; }
.feature i { color: #722ed1; }
.hero { background-size: 200% 200%; animation: gradientShift 14s ease infinite; }
.hero::before { content: ""; position: absolute; inset: 0; background: radial-gradient(600px 300px at 15% 10%, rgba(255,255,255,0.35), transparent 60%), radial-gradient(500px 260px at 85% 20%, rgba(255,255,255,0.25), transparent 60%); pointer-events: none; }
@keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
.shapes li { filter: blur(0.2px); opacity: 0.7; }
.shapes li:nth-child(1){ width: 18px; height: 18px; animation-duration: 5s; animation-delay: .2s; }
.shapes li:nth-child(2){ width: 22px; height: 22px; animation-duration: 6.5s; animation-delay: .6s; }
.shapes li:nth-child(3){ width: 14px; height: 14px; animation-duration: 4.8s; animation-delay: .1s; }
.shapes li:nth-child(4){ width: 28px; height: 28px; animation-duration: 7s; animation-delay: .4s; }
.shapes li:nth-child(5){ width: 16px; height: 16px; animation-duration: 5.6s; animation-delay: .3s; }
/* Badge glow pulse */
.badge { box-shadow: 0 0 0 rgba(114,46,209,0.0); animation: glowPulse 3.2s ease-in-out infinite; }
@keyframes glowPulse { 0%,100% { box-shadow: 0 0 0 rgba(114,46,209,0); } 50% { box-shadow: 0 8px 18px rgba(114,46,209,0.22); } }
.actions .el-button { transition: transform .25s ease, box-shadow .25s ease; }
.actions .el-button:hover { transform: translateY(-2px) scale(1.02); box-shadow: 0 10px 22px rgba(114,46,209,0.18); }

/* Custom button styling */
.actions .custom-button {
	background: #722ed1;
	border-color: #722ed1;
	color: white;
}
.actions .custom-button:hover {
	background: #9254de;
	border-color: #9254de;
	box-shadow: 0 10px 22px rgba(114,46,209,0.18);
}
/* Feature cards entrance with floaty animation */
.feature { animation: cardIn .5s ease both, floaty 6.5s ease-in-out .6s infinite; }
.feature:nth-child(1){ animation-delay: .05s; }
.feature:nth-child(2){ animation-delay: .12s; }
.feature:nth-child(3){ animation-delay: .19s; }
.feature:nth-child(4){ animation-delay: .26s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }

/* Button breathing */
.actions .el-button { animation: breathe 3.6s ease-in-out .2s infinite; }
@keyframes breathe { 0%,100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-1px) scale(1.03); } }
.ribbons { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; z-index: 0; }
.ribbons li { position: absolute; left: -10%; right: -10%; height: 140px; filter: blur(18px); opacity: 0.55; background: linear-gradient(90deg, rgba(114,46,209,0.0), rgba(114,46,209,0.45), rgba(114,46,209,0.0)); animation: sweep 9s ease-in-out infinite; }
.ribbons li:nth-child(1){ top: 10%; }
.ribbons li:nth-child(2){ top: 45%; animation-delay: 1.2s; height: 160px; opacity: 0.6; }
.ribbons li:nth-child(3){ top: 78%; animation-delay: 2.4s; height: 130px; opacity: 0.5; }
@keyframes sweep { 0% { transform: translateX(-10%) rotate(0.5deg);} 50% { transform: translateX(10%) rotate(-0.5deg);} 100% { transform: translateX(-10%) rotate(0.5deg);} }
@keyframes titleShimmer { 0% { background-position: 0% 50%; } 100% { background-position: 200% 50%; } }
</style> 